module.exports = __webpack_public_path__ + "static/img/img5.fc91b009.png";